<template>
  <a-card :bordered="false" class="m-b-10">
    <a-button size='small' @click="()=>{$router.go(-1)}">
      <LeftOutlined />返回
    </a-button>
    <span class="ml15 card_title">{{$route.query.activity_name}}(数据统计到昨天的数据)</span>
  </a-card>
  <a-card :bordered="false" class="m-b-20">
    <a-card class="width80 m-b-30" :bodyStyle="{padding:0}" :bordered="false">
      <div class="s_flex_ali height-120">
        <div class="width25 s_flex_center p-20" :class="type=='scan_total'?'active':''" @click="changeNav('scan_total')">
          <div>
            <p>扫码总次数
              <a-tooltip placement='right'>
                <template #title>
                  <p>扫码参与活动的总次数，包含重复领奖次数</p>
                </template>
                <InfoCircleOutlined class="fz-18 s_c376" />
              </a-tooltip>
            </p>
            <p class="fz-30 s_font_b">{{detail.scan_total}}</p>
          </div>
        </div>
        <div class="width25 s_flex_center p-20" :class="type=='award_number'?'active':''" @click="changeNav('award_number')">
          <div>
            <p>中奖总次数
              <a-tooltip placement='right'>
                <template #title>
                  <p>首次扫码的次数</p>
                </template>
                <InfoCircleOutlined class="fz-18 s_c376" />
              </a-tooltip>
            </p>
            <p class="fz-30 s_font_b">{{detail.award_number}}</p>
          </div>
        </div>
        <div class="width25 s_flex_center p-20" :class="type=='award_user'?'active':''" @click="changeNav('award_user')">
          <div>
            <p>中奖总人数
              <a-tooltip placement='right'>
                <template #title>
                  <p>首次扫码的人数，去重</p>
                </template>
                <InfoCircleOutlined class="fz-18 s_c376" />
              </a-tooltip>
            </p>
            <p class="fz-30 s_font_b">{{detail.award_user}}</p>
          </div>
        </div>
        <div class="width25 s_flex_center p-20" :class="type=='bonus_num'?'active':''" @click="changeNav('bonus_num')">
          <div>
            <p>发放红包总金额
              <a-tooltip placement='right'>
                <template #title>
                  <p>活动发放的总红包金额，包含发放失败，发放成功，发放异常红包</p>
                </template>
                <InfoCircleOutlined class="fz-18 s_c376" />
              </a-tooltip>
            </p>
            <p class="fz-30 s_font_b">{{detail.bonus_num}}</p>
          </div>
        </div>
        <div class="width25 s_flex_center p-20" :class="type=='point_num'?'active':''" @click="changeNav('point_num')">
          <div>
            <p>发放积分总数
              <a-tooltip placement='right'>
                <template #title>
                  <p>活动发放的积分总数</p>
                </template>
                <InfoCircleOutlined class="fz-18 s_c376" />
              </a-tooltip>
            </p>
            <p class="fz-30 s_font_b">{{detail.point_num}}</p>
          </div>
        </div>
      </div>
      
    </a-card>
    <a-card :bordered="false">
    <div class=" s_po_re" style="min-height:420px">
         <lineChart ref="myChart" v-show="!Loading" :activity_id="$route.query.activity_id" :type="type"></lineChart>
    </div>
    </a-card>
    <div style="padding:10px;font-weight: 600;font-size:20px">门店扫码占比</div>
    <a-table :pagination='false' bordered :columns='columns1' :data-source='list'>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="search.total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
</template>
<script>
import { useTime } from "@/hooks/utils/useTime";
import { reactive, ref, toRefs } from "@vue/reactivity";
import { inject, onMounted } from "@vue/runtime-core";
import { guide_activity_statisticalDetail,activity_store_statistical } from "@/api/guide";
import lineChart from './lineChart'
import { LeftOutlined } from "@ant-design/icons-vue";
export default {
  components: {lineChart,LeftOutlined },
  setup() {
    const search = ref({
      total: 0,
      limit: 10,
      page: 1,
    });
    const state = reactive({
      list: [],
      total: 0,
      detail: { },
      type:"scan_total",
    });

    const { dateTargets, typeToStartEnd } = useTime();
    const onSearch = () => {
      getDetail()
      initData()
    };
    let columns1 = [
      {
        title: "门店编号",
        dataIndex: "store_code",
        key: "store_code",
      },
      {
        title: "门店名称",
        dataIndex: "store_name",
        key: "store_name",
      },
      {
        title: "所属上级",
        dataIndex: "parent_name",
        key: "parent_name",
      },
      {
        title: "中奖次数",
        dataIndex: "award_number",
        key: "award_number",
      },
      {
        title: "中奖人数",
        dataIndex: "award_user",
        key: "award_user",
      },
      {
        title: "红包金额",
        dataIndex: "bonus_num",
        key: "bonus_num",
      },
      {
        title: "积分数量",
        dataIndex: "point_num",
        key: "point_num",
      },
    ];
    var $route = inject("$route");
    const form = ref({});
    var getDetail = async () => {
      let result = await guide_activity_statisticalDetail($route.query.activity_id,)
        .then((res) => res.data)
        .catch((error) => error);
      state.detail = result.data;
    };
    var initData=async ()=>{
      let result =await activity_store_statistical($route.query.activity_id,{
        ...search.value,
        ...form.value,
        type:state.type
      }).then(res=>res.data).catch(error=>error)
      state.list=result.data.data
      search.value.total=result.data.total
    }
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData()
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData()
    };
    onMounted(() => {
      initData()
      getDetail()
    });
    const myChart=ref('')
    const changeNav=(type)=>{
      console.log(type)
      state.type=type
     setTimeout(() => {
        myChart.value.initData()
     },50);
    }
    return {
      ...toRefs(state),
      search,
      pageCurrentChange,
      pageSizeChange,
      onSearch,
      columns1,
      form,
      myChart,
      changeNav
    };
  },
};
</script>
<style lang="less" scoped>
.data-content-nav {
  background: #eee;
  border-radius: 10px;

  .data-content-nav-item {
    color: #8e8e8e;
    font-size: 14px;
    padding-top: 20px;
    padding-bottom: 20px;
    cursor: pointer;
    text-align: center;
    .title {
      font-size: 16px;
      color: #000000;
    }

    .num {
      font-size: 34px;
      color: #000;
    }
    &.active {
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(27, 66, 108, 0.28);
      border-radius: 10px;
    }
  }
}
.active {
  border: 1px solid #bbddff;
  box-shadow: 7px 5px 22px 0px #9cb9d7;
  position: relative;
  left: -5px;
  top: -5px;
  border-radius: 10px;
}
</style>